module.exports = {
    CONECTION_ERROR: 'Error de conexíon con el servidor',
    NOT_FOUND: 'No se encontraro la ruta de la solicitud',
    DEFAULT_ERROR: 'Error',
}
